// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import {
  Card,
  CircularProgress,
  Fade,
  Grid,
  Icon,
  InputLabel,
  Modal,
  Tooltip,
} from "@mui/material";

import { gql, useMutation } from "@apollo/client";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "80%", sm: "50%", xxl: "40%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalNuevoTipo({ open, handleClose, refetchTipo }) {
  const { handleSnackbar } = useContext(MessageManager);

  const [tipoProducto, setTipoProducto] = useState("");

  const [saveTipoProducto, { loading }] = useMutation(
    gql`
      mutation saveTipoProducto($input: TipoProductoInput!) {
        saveTipoProducto(input: $input) {
          id
        }
      }
    `
  );

  const handleSave = () => {
    saveTipoProducto({
      variables: {
        input: {
          tipo: tipoProducto,
        },
      },
    })
      .then(() => {
        handleSnackbar("Guardado correctamente", "success");
        refetchTipo();
        handleClose();
      })
      .catch((error) => {
        const errorMessage = error?.graphQLErrors?.[0]?.message || "Error al guardar";
        handleSnackbar(errorMessage, "error");
      });
  };
  useEffect(() => {
    if (!open) {
      setTipoProducto("");
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={12} display="flex" flexDirection="row" justifyContent="space-between">
              <Grid></Grid>
              <SoftTypography variant="h6" align="center">
                Nuevo Tipo
              </SoftTypography>
              <Grid>
                <Tooltip title="Cerrar" placement="top">
                  <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                    close
                  </Icon>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <InputLabel htmlFor="precioCarta">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Nombre
                </SoftTypography>
              </InputLabel>
              <SoftInput
                placeholder="Ej: (Pizzas, Hamburguesas, Vinos, etc)"
                label="Nombre"
                value={tipoProducto}
                onChange={(e) => setTipoProducto(e.target.value)}
              />
            </Grid>
            <Grid item sm={8}></Grid>
            <Grid item xs={12} sm={4}>
              <SoftButton
                color="uproGreen"
                circular
                fullWidth={{
                  xs: true,
                  sm: false,
                }}
                onClick={handleSave}
                disabled={loading}
              >
                {false ? (
                  <CircularProgress size={15} color="inherit" />
                ) : (
                  <Icon sx={{ fontWeight: "light" }}>save</Icon>
                )}
                &nbsp;Guardar
              </SoftButton>
            </Grid>
          </Grid>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalNuevoTipo.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetchTipo: PropTypes.func,
};
